function setupCreateAccount() {
  var $error = $('.create-account-error-text');
  var $internalError = $('.create-account-internal-error-text');

  $('.create-account').each(function () {
    var $el = $(this);

    var $form = $el.find('.create-account-form');
    var $email = $form.find('.create-account-email');
    var $submit = $form.find('.create-account-button');
    var $processing = $form.find('.create-account-processing');

    var submitted = false;

    $form.submit(function() {
      if (submitted) {
        return;
      }

      submitted = true;

      $email.removeClass("create-account-has-error");

      var error = false;

      var emailCompare = /^[a-zA-Z0-9\+._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,25}$/i;
      var email = $email.val().trim();

      if (email == "") {
        $email.addClass("create-account-has-error");
        $email.attr("placeholder", "Please enter your email");
        error = true;
      } else if (!emailCompare.test(email)) {
        $email.addClass("create-account-has-error");
        error = true;
      }

      if (error) {
        submitted = false;
        return false;
      }

      $submit.hide();
      $processing.show();
      $error.hide();
      $internalError.hide();

      setTimeout(function() {
        let url = 'https://app.koofr.net/signup?email=' + encodeURIComponent(email);

        if (document.location.hostname === 'koofr.si') {
          url += '&lang=sl';
        }

        document.location.href = url;
      }, 10);

      return false;
    });
  });
}

window.initHome = function() {
  var looping = false;
  $(window).scroll(function() {
    if ($(this).scrollTop() > 0){
        $('.header').addClass("header-border");
        if (!looping) {
          loopImages();
        }
    }
    else{
        $('.header').removeClass("header-border");
    }
  });

  function loopImages() {
    if (looping) {
      return
    }
    looping = true;

    var imageClasses = ['feature-top-1--drive', 'feature-top-1--fb', 'feature-top-1--onedrive', 'feature-top-1--dropbox']
    var index = 0;
    setTimeout(function() {
      setInterval(function() {
        $('.feature-top-1').removeClass(imageClasses[index]);
        index = (index + 1) % imageClasses.length;
        $('.feature-top-1').addClass(imageClasses[index]);
      }, 3000);
    }, 2000)
  }
}


$(function () {
  setupCreateAccount();
});
